
import React from 'react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-battery-charge-line',
      title: 'Cellular Energy Boost',
      description: 'Dramatically increase ATP production and cellular energy levels for enhanced vitality and endurance.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Mental Clarity',
      description: 'Improve cognitive function, focus, and memory through enhanced neuronal energy metabolism.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'DNA Repair',
      description: 'Activate cellular repair mechanisms to protect against DNA damage and oxidative stress.'
    },
    {
      icon: 'ri-time-line',
      title: 'Anti-Aging Effects',
      description: 'Slow cellular aging processes and promote longevity through sirtuin activation.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Metabolic Enhancement',
      description: 'Optimize metabolism, improve insulin sensitivity, and support healthy weight management.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Addiction Recovery',
      description: 'Support neurotransmitter balance and reduce cravings in addiction recovery protocols.'
    },
    {
      icon: 'ri-moon-line',
      title: 'Sleep Quality',
      description: 'Regulate circadian rhythms and improve sleep quality through cellular clock optimization.'
    },
    {
      icon: 'ri-emotion-line',
      title: 'Mood Enhancement',
      description: 'Support neurotransmitter production and improve mood, reducing anxiety and depression.'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Transform Your Health with <strong>NAD+ Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Experience the powerful benefits of NAD+ therapy as your cells regain their youthful energy and function.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 lg:p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-green-700 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 lg:p-12 text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4 lg:mb-6">
              Ready to Restore Your Cellular Energy?
            </h3>
            <p className="text-lg lg:text-xl mb-6 lg:mb-8 opacity-90 max-w-2xl mx-auto">
              Join thousands of patients who have experienced the life-changing benefits of NAD+ therapy.
            </p>
            <button className="bg-white text-green-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Schedule NAD+ Treatment
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
